import React, { useState } from 'react';
import s from './InputGenerate.module.css';
import GenerateButton from '../generate-button/GenerateButton';
import { useAppDispatch } from '../../../../store/store';
import { useEffect } from 'react';
import { useDebounce } from '../../../../shared/hooks/useDebounce';
import { setInputPrompt } from '../../../../store/slices/projectSlice';
import { selectInputPrompt } from '../../../../store/selectors/projectSelectors';
import { useSelector } from 'react-redux';
type InputGenerateProps = {
    activeEditorMode: string;
    currentProject: any;
    imageProject: any;
    selectedImage: any;
    saveImage: () => Promise<void>;
};
const InputGenerate = ({
    activeEditorMode,
    currentProject,
    imageProject,
    selectedImage,
    saveImage,
}: InputGenerateProps) => {
    const dispatch = useAppDispatch();
    const [prompt, setPrompt] = useState('');
    const debouncedInputPrompt = useDebounce(prompt, 500);
    const inputPrompt = useSelector(selectInputPrompt);
    useEffect(() => {
        if (activeEditorMode === 'Visual') {
            if (imageProject?.allImagesForLayouts[0]?.prompt) {
                setPrompt(imageProject?.allImagesForLayouts[0]?.prompt);
            } else {
                setPrompt('');
            }
        }
        if (activeEditorMode === 'Captions') {
            setPrompt(currentProject?.prompt || '');
        }
    }, [activeEditorMode, imageProject]);

    useEffect(() => {
        dispatch(setInputPrompt(prompt));
    }, [debouncedInputPrompt]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPrompt(e.target.value);
    };
    useEffect(() => {
        setPrompt(inputPrompt);
    }, [inputPrompt]);
    return (
        <div className={s.container}>
            <input
                className={s.input}
                type="text"
                placeholder="Add a prompt or idea to generate a new image..."
                value={prompt}
                onChange={handleInputChange}
            />
            <div className={s.generate_button}>
                <GenerateButton
                    saveImage={saveImage}
                    activeEditorMode={activeEditorMode}
                    currentProject={currentProject}
                    prompt={prompt}
                    imageProject={imageProject}
                    selectedImage={selectedImage}
                />
            </div>
        </div>
    );
};

export default InputGenerate;
